import * as React from 'react';
import { useState, useContext, useEffect } from 'react';
import {DataContext, PolicyContext, DirtyContext} from "~common/form/icg-definition-data-provider";
// import {DataContext, PolicyContext} from "~common/form/icg-definition-data-provider";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import * as jsonpatch from "../components/jsonpatch";
import * as request from "superagent";
import Renderers from '~common/lib/renderers';
import * as moment from 'moment';
import { Definition, PredefinedField } from '../lib/types';
import classNames from 'classnames';
import { buildSectionTitle, applyConditional, getValueAtPath, setValueAtPathWithOpts, getFieldFromDefinition } from './helper';
import SimpleConfirmationModal from "~common/components/simple-confirmation-modal";
import PortalUser from `~common/lib/portal-user-context`;
import  Field  from '../components/form-def-field-fc' 
import CookieManager from "~common/lib/cookie-manager";
import {cloneDeep, merge, clone, isEqual } from 'lodash';
import Accordion from '@mui/material/Accordion';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Snackbar from '@mui/material/Snackbar';
import DefinitionSectionImport  from './definition-section-import';
import {FormItemList} from './form-item-list-fc';
import {
  Grid,
  Typography,
  IconButton,
  Button,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';

// BD Todo: make a "handleItemDelete"
// BD Todo: definition Custom renderers
// BD Todo: handle onValidate and handleValidate locally
// BD Todo: what does OnDefintionChange do and where does it come from?

// Tech Notes:
// Search for comments starting with "RENDER" for the exact cases where we are rendering the definition


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      fontFamily: 'Roboto,Arial,sans-serif;',
      width: '100%',
      display: "flex",
      flexDirection: "column"
    },
    preventCollapseContainer: {
      padding: 10
    },
    formHelperText: {
      marginBottom: 10
    },
    overlay: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      opacity: 0.8,
      zIndex: 999,
      backgroundColor: '#fff'
    },
    sectionTitle: {
      marginTop: "5px 5px 5px 5px !important",
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center',
      fontSize: '1.15rem',
      color: '#555',
      margin: '15px 0'
    },
    embeddedSectionTitle: {
      marginTop: 15,
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Roboto,Arial,sans-serif;',
      fontSize: '1.15rem',
      fontWeight: 500,
      color: '#555',
      margin: '15px 0'
    },
    blankTitle: {
      // marginTop: 15,
      // paddingBottom: 7,
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Roboto,Arial,sans-serif;',
      fontSize: '1.15rem',
      fontWeight: 500,
      color: '#555',
      // margin: '15px 0'
    },
    sectionArea: {
      display: 'flex',
      //flexDirection: "row-reverse",
      alignItems: 'baseline'
    },
    dialog: {
      maxWidth: '900px'
    },
    dialogTitle: {
      fontSize: '1.3125rem',
      fontWeight: 500,
      display: 'flex',
      justifyContent: 'space-between'
    },
    dialogFieldType: {
      color: '#ccc'
    },
    formArea: {
      paddingLeft: 5,
      paddingRight: 5
    },
    formAreaOutdent: {
      paddingTop: 15,
      paddingRight: 15
    },
    fieldArea: {
      display: 'flex',
      height: "100%"
    },
    formFieldContainer: {
      display: 'flex',
    },
    blankFormLine: {
      padding: '0px !important',
      margin: 0
    },
    paper: {
      boxShadow: "0px 0px 0px #FFFFFF;none"
    },
    itemListPanel: {
      boxShadow: "0px 0px 0px #FFFFFF;none",
      width: "100%",
      marginBottom: 15
    },
    itemListDetails: {
      boxShadow: "0px 0px 0px #FFFFFF;none",
      padding: 0
      // width: "100%"
    },
    summaryPanel: {
      margin: "0px 0px",
      boxShadow: "0px 0px 0px #FFFFFF;none",
      width: "auto",
      fontSize: '1.15rem',
      fontWeight: 500,
      color: '#555',
      fontFamily: 'Roboto,Arial,sans-serif;'
    },
    configIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 5,
      marginLeft: 5,
      fontSize: '0.9rem'
    },
    details: {
      height: "100%",
      padding: 5,
      display: 'flex',
    },
    detailsWrapper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    AccordionDetails: {
      width: "100%",
      // padding: 10
    },
    instructions: {
      fontSize: '1rem',
      color: '#303030',
      marginBottom: 30,
      width: "100%"
    },
    errorInstructions: {
      // padding: 15,
      paddingLeft: 15,
      fontSize: '1rem',
      color: '#f44336',
      width: "100%"
    },
    warnInstructions: {
      // padding: 15,
      paddingLeft: 15,
      fontSize: '1rem',
      color: '#ffae42',
      width: "100%"
    },
    historyInstructions: {
      padding: 15,
      fontSize: '1rem',
      color: '#1614b3',
      width: "100%"
    },
    historyArea: {
      display: 'flex',
      //flexDirection: "row-reverse",
      width: 500,
      alignItems: 'center',
      marginLeft: 10
    },
    historyButton: {
      width: 175,
      // bottom: 10,
      right: 225,
      alignItems: 'center',
    },
    historyBack: {
      width: 50,
      alignItems: 'flex-start',
      // bottom: 10,
      flexGrow: 1
    },
    historyStep: {
      alignItems: 'center',
      // bottom: 10,
      flexGrow: 2
    },
    historyForward: {
      width: 50,
      // bottom: 10,
      alignItems: 'flex-end',
      flexGrow: 1
    },
    historyToggleArea: {
      // overflow: 'hidden',
      // margin: '-20px -25px 0px -25px',
      // transition: 'height .25s ease-in-out',
      // position: 'relative'
    },
    historyToggle: {
      bottom: 10,
      right: 225,
      opacity: 0.7
    },
    historyEnable: {
      bottom: 10,
      right: 225,
      opacity: 0.3
    },
    successIcon: {
      color: 'green',
      fontSize: '0.9rem',
      paddingRight: 5
    },
    infoIcon: {
      color: '#005897',
      fontSize: '0.9rem',
      paddingRight: 5
    },
    warnIcon: {
      color: 'gold',
      fontSize: '0.9rem',
      paddingRight: 5
    },
    errorIcon: {
      color: '#f44336',
      fontSize: '0.9rem',
      paddingRight: 5
    },
    actionBar: {
      marginTop: 15
    },
    subDefinitions: {
      display: 'flex',
      width: '100%'
    },
    subDefinition: {
      // To make subdefinitions fill the parent space
      // flex: 1,
      // To allow children to do the same
      display: 'flex',
      // BD TODO
      // marginBottom: theme.spacing(3)
  
    }
  })
);

interface DefinitionRendererProps {
  path: string;
  definition: any;
  titleOverride?: string;
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  customRenderers?: any;
  // readOnly prop for any rendered fields. 
  readOnly?: boolean;
  // Index of the section to display. If provided only that section will be displayed.
  sectionIDX?: number;
  emptySetRenderers?: any;
  preventCollapse?: boolean;
  embedded?: boolean;
  suppressTitle?: boolean;
  suppressFirstTitle?: boolean;
  suppressHistory?: boolean;
  triggerSubmit?: Function;
}

interface HistoryModeOpts {
  historicalView?: boolean;
  historyStep?: number;
  historicalData: any;
  stashedData: any;
}

export const DefinitionSection: React.FC<DefinitionRendererProps> = ({
  definition,
  path,
  titleOverride,
  gridSpacing,
  customRenderers,
  suppressHistory,
  readOnlyExceptionPaths, // paths that are editable in readOnly mode (attachments in AP invoice search)
  readOnly,
  sectionIDX,
  embedded,
  preventCollapse,
  emptySetRenderers,
  suppressTitle,
  suppressFirstTitle,
  triggerSubmit,
  onHistoryViewToggle
}) => {

  const [fullData, setFullData] = useContext(DataContext);
  const [policyMessages, setPolicyMessages] = useContext(PolicyContext);
  const [formDirty, setFormDirty] = useContext(DirtyContext);

  
  const classes = useStyles(); 
  // const [defData, setDefData] = useState(onAccessRootData(path));
  if (!path) {
    path = ''
  }
  var initialDefData = getValueAtPath(path, fullData)

  const [snackbarContent, setSnackbarContent] = useState(null)
  // const [defData, setDefData] = useState(fullData);
  const [defData, setDefData] = useState(initialDefData);
  const [historyModeOpts, setHistoryModeOpts] = useState({} as HistoryModeOpts);
  const [triggerConfirmationMessage, setTriggerConfirmationMessage] = useState("");
  const [triggerValidationData, setTriggerValidationData] = useState(null);
  const [managedWindows, setManagedWindows] = useState([])
  const [gridAttributeOverride, setGridAttributeOverride] = useState(undefined)


  const defaultTriggerConfirmationMessage = "Changing this field will trigger changes to other fields. Would you still like to change this value?"

  var pathExt = path + '/';
  var isTitleSuppressed = suppressTitle || suppressFirstTitle
  if (definition && definition.suppressTitle) {
    isTitleSuppressed == true
  }
  var instructions: any = null;


  if (gridAttributeOverride && gridAttributeOverride.current) {
    if (definition && definition.definitions && definition.definitions.length > 0) {
      definition.definitions.forEach((defsec: any) => {
        if (gridAttributeOverride.current[defsec.key]) {
          defsec.gridAttributes = gridAttributeOverride.current[defsec.key];
        }
      })
    }
  }

  const getPolicyMessageClass = (policyMessage: any) => {
    switch (policyMessage.severity) {
      case 1:
        return classes.warnInstructions
      case 2:
        return classes.errorInstructions
      case 4:
        return classes.historyInstructions
      default:
        return undefined
    }
  }

  // Helper Functions

  const handleAPIError = (err: any, terminal?: boolean) => {
    var pms = policyMessages
    try {
      pms = JSON.parse(err.response.text)
    } catch (e) {
      console.error("Error Parsing Policy Messages", e)
    }
    setPolicyMessages(pms)
  };

  const onEvaluateConditional = (huh: any) => {

    return null
  }

  const onAccessRootData = (fullPath: any) => {
    var trimmedPath = fullPath.replace('~', '');
    var newData = getValueAtPath(trimmedPath, fullData)
    return newData
  }

  const onFileReject = (huh: any) => {
    return null
  }

  const showAsPopout = (key: string) => (event: any) => {
    event.preventDefault();
    const self = this;

    var _managedWindows = managedWindows

    const fn = (event) => {
      _managedWindows.forEach((w) => {
        w.close()
      })
    }

    window.addEventListener("unload", fn);
    _managedWindows.push(window.open("/forms/definition-view", key, "resizable=1,address=no,height=800,width=640,location=no"))
    setManagedWindows(_managedWindows)
  }

  const handleHistory = (historicalURL: string) => {
    const self = this
    return function (evt: any) {
      // The stop propogation/prevent default stops the accordian from rolling up when using these buttons
      evt.stopPropagation()
      evt.preventDefault();
      if (onHistoryViewToggle) {
        onHistoryViewToggle(true)
      }
      request.post(historicalURL).send(fullData).then((response: request.Response) => {
        // This historicalURL must be set up for each form, but is always expected to return a slice of "historyPatch"s, which will contain data (whatever data can be set to state), policyMessages (formulated from the patch diffs), and the updated at and updated by of who made the changes reflected in the patch. 
        if (response.body && response.body.historyPatch && response.body.historyPatch[0]) {
          setPolicyMessages(response.body.historyPatch[0].policyMessages)
          setHistoryModeOpts({
            historicalView: true,
            historyStep: 0,
            historicalData: response.body.historyPatch,
            // Stashed data holds the users changes when going into history mode
            stashedData: cloneDeep(fullData),
          })
          // signal up-stream that history mode has been enabled
         
        }
      }).catch((err) => {
        handleAPIError(err)
        if (onHistoryViewToggle) {
          onHistoryViewToggle(false)
        }
      })
    }

  }

  const handleHistoryClose = (evt: any) => {
    evt.stopPropagation()
    evt.preventDefault();
    if (historyModeOpts.historicalView) {
      setFullData(historyModeOpts.stashedData)
      setPolicyMessages(null)
      setHistoryModeOpts({
        historicalView: false,
        historyStep: 0,
        historicalData: {},
        // Stashed data holds the users changes when going into history mode
        stashedData: null,
      })
      // signal up-stream that history mode has been disabled
      if (onHistoryViewToggle) {
        onHistoryViewToggle(false)
      }
    }
  }


  const handleHistoryForward = (evt: any) => {
    var newOpts = cloneDeep(historyModeOpts)
    evt.stopPropagation()
    evt.preventDefault();
    var newStep = historyModeOpts.historyStep - 1
    newOpts.historyStep = newStep

    if (historyModeOpts.historicalData[newStep] && historyModeOpts.historicalData[newStep].policyMessages) {
      if (historyModeOpts.historicalData[newStep].data) {
        setFullData(historyModeOpts.historicalData[newStep].data)
        setPolicyMessages(historyModeOpts.historicalData[newStep].policyMessages)
        setHistoryModeOpts(newOpts)

      } else {
        // If there are no further steps forward, we need to revert to the most current set of the data, aka the data that was stashed off the state when history mode was added.
        setFullData(historyModeOpts.stashedData)
        setPolicyMessages(historyModeOpts.historicalData[newStep].policyMessages)
        setHistoryModeOpts(...historyModeOpts, {historyStep: newStep})
      }
    }
  }

  const handleHistoryBack = (evt: any) => {
    var newOpts = cloneDeep(historyModeOpts)
    evt.stopPropagation()
    evt.preventDefault();
    var newStep = historyModeOpts.historyStep + 1
    newOpts.historyStep = newStep
    if (historyModeOpts.historicalData[newStep] && historyModeOpts.historicalData[newStep].policyMessages) {
      setFullData(historyModeOpts.historicalData[newStep].data)
      setPolicyMessages(historyModeOpts.historicalData[newStep].policyMessages)
      setHistoryModeOpts(newOpts)
    }
  }
  

  const handleOnApplyConditional = (
    basisPath: string,
    conditionalAttribute: any,
    i: any,
    field: PredefinedField
  ) => {
    // if (onApplyConditional) {
    //   onApplyConditional(basisPath, conditionalAttribute, i, field);
    // } else {
      // We are at the top of the chain
      // BD TODO: check if we actually want onEvaluateConditional or onAccessRootData on props
      applyConditional(path, conditionalAttribute, i, field, onAccessRootData);
    // }
  };
  const applyConditionalsToDefinition = (definition: any, data: any) => {
    if (definition && definition.predefined) {

      for(let i = 0; i < definition.predefined.length; i++) {
        var localField = definition.predefined[i];
        var path = localField.key || '';
        var pathExt = path + '/';
        
        if (path.length > 0) {
          pathExt = path + '/';
        }
        // if available, apply conditionals
        if (localField.conditionalAttributes) {
          localField.conditionalAttributes.map((attr) => {
            handleOnApplyConditional(
              pathExt + localField.key,
              attr,
              data || {},
              localField
            );
          });
        }
      }
    }
  }

  const clearMessagesAtPath = (path:string, messages: any) => {
    if(messages && messages.length>0){
      const pm = messages.reduce((acc, m)=>{
        let mp = m.path 
        if(mp.indexOf("/")==0){
          mp = mp.substring(1)
        }

        let op = path 
        if(op.indexOf("/")==0){
          op = op.substring(1)
        }

        if (mp != op) {
          acc.push(m)
        }

        return acc
      }, [])

      return pm
    } else {
      return []
    }
  }

  const handleTriggerChange = (path: string, data: any, fieldDef?: any) => {

    var triggerValidationAtURL = fieldDef.triggerValidationAtURL;
    if (triggerValidationAtURL.indexOf("?") > -1) {
      triggerValidationAtURL =
        triggerValidationAtURL + "&triggerPath=" + path;
    } else {
      triggerValidationAtURL =
        triggerValidationAtURL + "?triggerPath=" + path;
    }
    // Clear the snackbar
    setSnackbarContent(null)
    request
      .post(triggerValidationAtURL)
      .send(data)
      .then((response) => {

        let patch = response.body["diff"];

        let messages = policyMessages || [];

        // the field changed to trigger this validtion url, so clear old policy messages for this field. 
        messages = clearMessagesAtPath(path, messages)

        let newMessages = response.body["policyMessages"];
        if (newMessages) {
          var ignoreMessagesAtPath = [];

          for (let newMessage of newMessages) {
            if (newMessage.severity == 3) {
              ignoreMessagesAtPath.push(newMessage.path);
            }

            let duplicate = false;
            for (let message of messages) {
              if (
                message.message == newMessage.message &&
                message.path == newMessage.path
              ) {
                duplicate = true;
              }
            }
            if (duplicate != true) {
              messages.push(newMessage);
            }
          }

          // Remove messages which have a reset status
          for (let p of ignoreMessagesAtPath) {
            messages = messages.filter((m) => {
              return m.path != p;
            });
          }
        }

        if (response.body["responseMessage"]) {
          setSnackbarContent(response.body["responseMessage"])
        }
        let patchedData = jsonpatch.apply_patch(data, patch);
        let focusSelector = response.body["focusSelector"];

        setPolicyMessages(messages)
        setFullData(patchedData)
        
        var match = document.querySelector(focusSelector);
        if (match) {
          match.focus();
        }
        
    })
    .catch((err) => {
      // BD REVIEW: Is this the right way to handle error?
      if (err.response && err.response.text) {
        setSnackbarContent(err.response.text)
      }
     console.error(err)
    });
  };

  const denyTriggerValidationDialog = () => {
		if (triggerValidationData && triggerValidationData.revertData) {
      setFullData(triggerValidationData.revertData)
			} 
		
	  };

  const acceptTriggerValidationDialog = () => {
    if (triggerValidationData && triggerValidationData.path && triggerValidationData.fieldDef) {
      // this.setState({ data: data}, () => {
        var newPms = clearMessagesAtPath(triggerValidationData.path, policyMessages);
        setPolicyMessages(newPms)
        handleTriggerChange(triggerValidationData.path, fullData, triggerValidationData.fieldDef)
      // });
    } else {
      denyTriggerValidationDialog()
    }
    
  };

  // gets called after deny or accept
  const closeTriggerValidationDialog = () => {
    setTriggerConfirmationMessage("")
    setTriggerValidationData(null)
  };

  const handleRowItemDelete = (idx: any, path: string, newData: any, fieldDef: any) => {
    var pms = cloneDeep(policyMessages);
    var deepCloneData = cloneDeep(fullData)
    // filter out messages for the item that was just deleted.
    pms = policyMessages.filter((pm: any) => {
      return pm.path.indexOf(`${path}/${idx}`) == -1;
    });

    // adjust the index for other rows
    pms.forEach((pm: any) => {
      // identify remaining policy messages for the list
      if (pm.path.indexOf(`${path}/`) > -1) {
        var parts = pm.path.split("/");
        var pathIndex, partIndex;
        parts.forEach((p: string, pidx) => {
          var parsed = parseInt(p);
          // the part that is a number is the index that needs to be adjusted.
          if (!isNaN(parsed)) {
            pathIndex = parsed;
            partIndex = pidx;
          }
        });
        if (pathIndex) {
          if (pathIndex > idx) {
            pathIndex--;
          }
          parts[partIndex] = pathIndex;
          var newPath = parts.join("/");
          pm.path = newPath;
        }
      }
    });

    let svpResp = setValueAtPathWithOpts(path, deepCloneData, newData, null);

    setPolicyMessages(pms)
    setFullData(svpResp.data)
    setFormDirty(true)
  }

  const handleSubDefinitionChange = (idx: number) => (def: Definition) => {
    definition.definitions[idx] = def;
    handleDefinitionChange(definition);
  };

  const handleDefinitionChange = (def: Definition) => {
  };

  const onChangeDepr = (val: any) => {
    console.warn("HEY! I thought onChange wasn't used how are you getting in here?", val)
  };

  const handleCommitChange = (attribute: string) => (val: any) => {
    var fieldDef: any
    if (definition) {
      for (let preDefined of definition.predefined) {
        if (preDefined.key == attribute || preDefined.path == attribute) {
          fieldDef = preDefined
        } 
      }
    }
    
    const alteredField = new PredefinedField(cloneDeep(fieldDef));
    let deepCloneData = cloneDeep(fullData);

    var fullPath = pathExt + attribute
    let origVal = getValueAtPath(fullPath, fullData)
    let svpResp = setValueAtPathWithOpts(fullPath, deepCloneData, val, null)
    // BD TODO: can we make this simpler and not have to clone twice just to check if the triggerValidationAtURL changed?
    if (alteredField.conditionalAttributes) {
      alteredField.conditionalAttributes.map((attr) => {
        applyConditional(fullPath, attr, svpResp.data, alteredField, onAccessRootData);
      });
    }

    if (alteredField && alteredField.triggerValidationAtURL) {
      if (alteredField.requireTriggerConfirmation) {
        let stashData = cloneDeep(fullData);
      
        setTriggerConfirmationMessage(fieldDef.triggerConfirmationMessage || defaultTriggerConfirmationMessage)
        setTriggerValidationData({path: fullPath, value: val, revertData: stashData, newData: svpResp.data, fieldDef: alteredField})
        setFullData(svpResp.data)
      } else {
        setFormDirty(true)
        handleTriggerChange(fullPath, svpResp.data, fieldDef)
      }
    } else {
      let deepCloneMessages = cloneDeep(policyMessages);

      if (val != origVal) {
        // Only clear the messages if the value has changed
        let newPMs = clearMessagesAtPath(fullPath, deepCloneMessages)
        setPolicyMessages(newPMs)
      }
      setFullData(svpResp.data)
      setFormDirty(true)
    }
    
  };

  

  const fieldBuilder = () => (
    acc: any,
    f: any,
    idx: number
  ): any => {
    let key = 'pf' + idx;
    var isActive = true

    const localField = new PredefinedField(cloneDeep(f));
    let configIcon: any = null;
    if (f.mode != 'Hidden') {
      isActive = true;
    }

    // Tech Review: do we need this still?
    // if (!localField.type) {
    //   console.warn(
    //     "reverting to default type 'Text' you should set the field types on the definition in the future",
    //     localField
    //   );
    //   localField.type = 'Text';
    //   localField.legacy = true;
    //   f.legacy = true;
    // }

    let FieldRenderer = Field;

    //do not use custom renderers in admin mode, since we have preview mode to accomodate that
    if (localField.customRenderer) {
      if (customRenderers) {

        const cr = customRenderers[localField.customRenderer];
        if (cr) {
          FieldRenderer = cr;
        } else {
          let fr = Renderers.find(localField.customRenderer)
          if (fr) {
            FieldRenderer = fr
          }

        }

      } else {

        let fr = Renderers.find(localField.customRenderer)
        if (fr) {
          FieldRenderer = fr
        }
      }
    }

    if (!localField.gridAttributes) {
      localField.gridAttributes = {};
    }

    // if available, apply conditionals
    if (localField.conditionalAttributes) {
      localField.conditionalAttributes.map((attr) => {
        handleOnApplyConditional(
          pathExt + localField.key,
          attr,
          defData || {},
          localField
        );
      });
    }

    if (f.mode != 'Hidden') {
      isActive = true;
    }

    let val = ""

    var fieldPath = localField.path || (pathExt + localField.key)



    if (localField.key) {
      // if 
        val = getValueAtPath(localField.key, defData)
    } else {
        val = defData[localField.key]
    }

    if (localField.path) {
      if (localField.path.indexOf("~") == 0) {
        val = getValueAtPath(localField.path, fullData)
        fieldPath = localField.path.substring(1)
      } else {
        val = getValueAtPath(localField.path, defData)
        fieldPath = (pathExt + localField.key)
      }
    }

    const fr = (
      <div className={classes.formFieldContainer} style={{ position: 'relative', width: '100%'}}>
        <FieldRenderer
          onFileReject={onFileReject}
          path={fieldPath}
          value={val}
          sectionData={defData}
          fieldDefinition={localField}
          onCommitChange={handleCommitChange((localField.path || localField.key))}
          customRenderers={customRenderers}
          policyMessages={policyMessages}
          readOnly={readOnly || historyModeOpts.historicalView}
          onAccessRootData={onAccessRootData}
          triggerAction={triggerSubmit}
        />
        {localField.mode === 'Hidden' && (
          <div className={classes.overlay} />
        )}
      </div>
    );

    

    var hrf = CookieManager.getCookie(
      `hiddenResultsFields|${window.location.pathname}`
    );

    var hiddenFields = []
    if (hrf) {
      hiddenFields = hrf.split("|")
    }

    
    
    if(hiddenFields.includes(localField.key) && definition.hidableResults && f.mode == 'Display'){
      var fieldStyleObj = { position: 'relative', width: '100%', display: 'none'}
    }

    if (localField.mode != 'Hidden') {
      // If we the field is not hidden at this point, the section is active.
      isActive = true

      if (localField.gridAttributes.newRow) {
        acc.push(
          <Grid
            key={'nr' + key}
            className={classes.blankFormLine}
            item
            // item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}>
            {' '}
          </Grid>
        );
      }
      acc.push(
        <Grid
          key={key}
          item
          xs={localField.gridAttributes.xs || 12}
          sm={localField.gridAttributes.sm || 6}
          md={localField.gridAttributes.md || 4}
          lg={localField.gridAttributes.lg || 3}
          xl={localField.gridAttributes.xl || 3}
          style={fieldStyleObj}>
          <div  className={classes.fieldArea}>
            {configIcon}
            {fr}
          </div>
        </Grid>
      );
    }
    return acc;
   
  };

  const renderDefinitions = () => {
    var definitionsArea: any = null;
    
    if (
      definition &&
      definition.definitions &&
      definition.definitions.length > 0
    ) {

      var defintionSections = definition.definitions.map(
        (d: any, idx: number): any => {

          let DefinitionRenderer = DefinitionSection;
          if (sectionIDX != undefined && sectionIDX != idx) {
            return null
          }

          const def = new Definition(cloneDeep(d));
          var subDefData = []
          if (defData) {
            subDefData = defData[def.key]
          }
          if (!def.gridAttributes) {
            // need at least this much so we can used the sizes or defaults
            def.gridAttributes = {}
          }

          if (def.allowsMultiples) {
            if (def.predefined && def.predefined.length > 0) {
              
              // run the field builder to see what the fields will look like after conditionals are applied. 
              var predefinedFields = def.predefined.reduce(
                fieldBuilder(),
                []
              );

              // if no fields are returned, then they have all been hidden
              if (predefinedFields.length == 0) {
                return null
              }

              // Add the predefined fields to the definition clone
              // Also, apply the conditional logic to the fields
              // BD Todo: DefData may be wrong here

              applyConditionalsToDefinition(def, subDefData || [])

            }

            const subSectionTitle = buildSectionTitle(
              classes,
              def,
              path,
              policyMessages,
              false,
              false,
              false,
              false
            );
            var itemListArea = renderItemListArea(def, idx, subDefData)

            if (!preventCollapse && !def.singleRecordSelector) { 
              // RENDER Allows multiples and has accoridian
              return (
                <Grid className={classes.subDefinition} key={"ds_" + def.key + "_" + idx} item xl={def.gridAttributes.xl || 12} lg={def.gridAttributes.lg || 12} md={def.gridAttributes.md || 12} sm={def.gridAttributes.sm || 12} xs={def.gridAttributes.xs || 12}>
                  
                  <Accordion elevation={0} style={def.styleAttributes} defaultExpanded={true} className={classes.itemListPanel}>
                    {subSectionTitle && def.title != "" &&
                      <AccordionSummary tabIndex={-1} className={classes.summaryPanel} expandIcon={<ExpandMoreIcon />}>
                        {subSectionTitle}
                      </AccordionSummary>
                    }
                    {subSectionTitle && def.title == "" &&
                    <div className={classes.blankTitle}>
                      {subSectionTitle}
                    </div>}

                    {def.allowsMultiplesTemplateImportEnabled && <div style={{float: "right"}}>
                      <DefinitionSectionImport definition={def} path={(pathExt + def.key)} handleChangeAtPath={onChangeDepr} />
                    </div>}
                    {/* Render instructions */}
                    {def.instructions && <FormHelperText className={classes.formHelperText}><div dangerouslySetInnerHTML={{ __html: def.instructions }}></div></FormHelperText>}
  
                    <AccordionDetails className={classes.itemListDetails}>
                    {itemListArea}
                    </AccordionDetails>

                  </Accordion>
                </Grid>
              )
            } else {
              // RENDER Allows multiples and has no accordian
              var sectionStyle = {position: 'relative'}
              sectionStyle = merge(d.styleAttributes, sectionStyle)
              return (
                <Grid className={classes.subDefinition} key={'grid_item_' + idx} item xl={def.gridAttributes.xl || 12} lg={def.gridAttributes.lg || 12} md={def.gridAttributes.md || 12} sm={def.gridAttributes.sm || 12} xs={def.gridAttributes.xs || 12}>
                  <div className={classes.itemListPanel} style={sectionStyle}>
                    <Typography variant="h5" className={classes.sectionTitle}>
                      {subSectionTitle}
                    </Typography>

                    {def.allowsMultiplesTemplateImportEnabled && <div style={{position: "absolute", top: 10, right: 10}}>
                      <DefinitionSectionImport definition={def} path={(pathExt + def.key)} handleChangeAtPath={onChangeDepr} />
                    </div>}

                    {def.instructions && <FormHelperText className={classes.formHelperText}><div dangerouslySetInnerHTML={{ __html: def.instructions }}></div></FormHelperText>}
                    {itemListArea}
                  </div>
                </Grid>
              )
            }
          } else {
            var defComp = definitionComponent(def, idx, subDefData, false)
            return (
              <Grid className={classes.subDefinition} key={'grid_item_' + idx} item xl={def.gridAttributes.xl || 12} lg={def.gridAttributes.lg || 12} md={def.gridAttributes.md || 12} sm={def.gridAttributes.sm || 12} xs={def.gridAttributes.xs || 12}>
                {defComp}
              </Grid>
            );
          }
        }
      );
        
      if (defintionSections.length > 0 && defintionSections.filter((section)=>{return section != null}).length > 0) {
        definitionsArea = (
          <Grid className={classes.subDefinitions}  container>
            {defintionSections}
          </Grid>
        );
      }
      return definitionsArea
    }
  }
  const renderItemListArea = (def: any, idx: number, subDefData: any) => {
    return (
      <FormItemList
        key={idx}
        path={pathExt + def.key}
        definition={def}
        readOnly={readOnly || historyModeOpts.historicalView}
        data={subDefData || []}
        multiFormSelector={def.multiFormSelector}
        handleTriggerChange={handleTriggerChange}
        suppressIconButtons={def.suppressIconButtons}
        // onChangeAtPath={onChangeAtPath}
        singleRecordSelector={def.singleRecordSelector}
        handleItemDelete={handleRowItemDelete}
        emptySetRenderers={emptySetRenderers}
        suppressTitle
        classes={{
          container: classes.container,
          sectionTitle: classes.subSectionTitle
        }}
        policyMessages={policyMessages}
        
        gridSpacing={gridSpacing || 1}
        // Definition is here
        itemRenderer={(i: any, idx: number): any => {
          return definitionComponent(def, idx, subDefData, true)
        }}
      />
    )
  }
  const definitionComponent = (def: any, idx: number, subDefData: any, allowsMultiples: boolean) => {
    let DefinitionRenderer = DefinitionSection;
    if (!subDefData) {
      subDefData = [];
    }

    var localsuppressTitle = suppressTitle
    var key = idx
    var path = pathExt + def.key
    var data = subDefData
    if (def.allowsMultiples) {
      localsuppressTitle = true
      key = def.key + "_" + idx
      path = pathExt + def.key + '/' + idx
      data = subDefData[idx]
    }

    var DefRenderer = DefinitionRenderer

    var handleTriggerChangeFunc
    if (def.customRenderer) {
      var cr
      if (customRenderers) {
        cr = customRenderers[def.customRenderer];
      } else {
        cr = Renderers.find(def.customRenderer)
      }
      if (cr) {
        DefRenderer = cr
        handleTriggerChangeFunc = handleTriggerChange
      }
    }

    var sectionIsReadOnly = clone(readOnly) // cloned to ensure reference is not altered
    if (readOnlyExceptionPaths && readOnlyExceptionPaths.length > 0) { 
      var exception = readOnlyExceptionPaths.find((p:any)=>{return p == path}) // check if current section path has been added as a readOnly exception
      if (exception) { 
        sectionIsReadOnly = false
      }
    }
    if (historyModeOpts.historicalView) {
      sectionIsReadOnly = true // all sections are readOnly in historical mode
    }
    
    return (
    <DefRenderer
      suppressTitle={allowsMultiples ? true : localsuppressTitle}
      key={key}
      path={path}
      preventCollapse={preventCollapse}
      definition={def}
      handleTriggerChange={handleTriggerChangeFunc}
      customRenderers={customRenderers}
      gridSpacing={gridSpacing || 1}
      embedded={embedded}
      readOnly={sectionIsReadOnly}
      readOnlyExceptionPaths={readOnlyExceptionPaths}
    />
    )
  }

  const renderFields = () => {
    let fieldArea: any = null;
    var predefinedFields: Array<any>;
    if (definition.predefined) {
      predefinedFields = definition.predefined.reduce(
        fieldBuilder(),
        []
      );
    } else {
      predefinedFields = [];
    }

    if (predefinedFields.length > 0) {
      let fieldAreaClass = classes.formArea;
      if (!definition.title && !titleOverride) {
        fieldAreaClass = classes.formAreaOutdent;
      }

      fieldArea = (
        <Grid
          spacing={gridSpacing || 1}
          className={fieldAreaClass}
          container>
          {predefinedFields}
        </Grid>
      );
    }

    return fieldArea
   
  };  

  const handleMessage = (message: any) => {
    if (message && message.data) {
      
      if (managedWindows.length > 0) {
        switch ((message.data.action || "").toLowerCase()) {
          case "datadidupdate":
            var newData = getValueAtPath(path, fullData)
            message.source.postMessage({
              action: "datadidupdate",
              data: newData,
            }, window.location.origin);
            break;
          case "ready":
            // The receiving window is ready for initial data
            let msg: any = {
              action: "onReadyStateChange",
              definition: definition,
              data: defData,
            }
            if (definition) {
              msg.sourceGridAttributes = JSON.parse(JSON.stringify(definition.gridAttributes))
            }

            message.source.postMessage(msg, window.location.origin)
            break;
          case "handlechangeatpath":
            if (definition.key == message.data.data.key) { 
              if (!isEqual(defData, message.data.data.value)) {
                var _fullData = cloneDeep(fullData)
                _fullData[definition.key] = message.data.data.value
                setFormDirty(true)
                setFullData(_fullData)
              }
            }
            break;
        }
      } else {
        switch ((message.data.action || "").toLowerCase()) {
          case "reset":

            var _gridAttributeOverride = cloneDeep(gridAttributeOverride)

            if (_gridAttributeOverride && _gridAttributeOverride.original) {

              _gridAttributeOverride.current = _gridAttributeOverride.original
  
              setGridAttributeOverride(_gridAttributeOverride)

            }
            break;
          case "datadidupdate":
            // TODO - not sure if this is needed???
            break;
          case "expand":
            var sga: any = {};
            sga.current = message.data.sectionGridAttributes;
            sga.original = {};

            (definition.definitions || []).forEach((d: any) => {
              if (sga.current[d.key]) {
                sga.original[d.key] = d.gridAttributes
              }
            })
  
            setGridAttributeOverride(sga)
            break;
        }
      }
    }
  }




  // Rendering Code
  if (!definition) {
    return null;
  }


  useEffect(()=>{ 
    window.addEventListener("message", handleMessage)
    return () => {
      window.removeEventListener("message", handleMessage)
    };
  }, [gridAttributeOverride, defData])
  
  // Hooks and functions for interaction
  // Looks for changes from the parent def
  useEffect(() => {
    var newData = getValueAtPath(path, fullData)

    if (managedWindows.length > 0) {
      managedWindows.forEach((mw: any) => {
        handleMessage({ source: mw, data: { "action": "datadidupdate" } })
      })
    }

    setDefData(newData);
    
  }, [fullData])



  let definitionClass = classes.container + " " + definition.key

  // Modal Renders
  var confirmTriggerValidationModal = null
  if (triggerConfirmationMessage && triggerConfirmationMessage != "") {
    confirmTriggerValidationModal = (
      <SimpleConfirmationModal
        terminal={true}
        open={true}
        confirmationMessage={
          triggerConfirmationMessage || "Changing this field will trigger changes to other fields. Would you still like to change this value?"
        }
        onClose={closeTriggerValidationDialog}
        onDeny={denyTriggerValidationDialog}
        onConfirm={acceptTriggerValidationDialog}
      />
    );
  }

  let popperIcon: any = undefined;
  if ((definition.popperAttributes) && !window.opener) {
    popperIcon = (
      <i onClick={showAsPopout(definition.key)} style={{ paddingLeft: 10, paddingRight: 10, cursor: 'pointer' }} className="material-icons ">launch</i>
    )
  }

  // History mode Renders

  let showsHistory = false

  var isTopPath = false
  if (path == "" || path == "/") {
    isTopPath = true
  }

  var historicalURL = ""
  if (definition.historicalURL && definition.historicalURL != "") {
    historicalURL = definition.historicalURL
  }

  // Logic to determine whether the history button is shown. It must be the top level definition, the form must have a historicalURL on the top level, and there must either not be a restrictHistoryToFeature or if present, the user must be logged in and have that feature.  
  if (isTopPath && historicalURL != "" && !suppressHistory) {
    showsHistory = true
    if (definition.restrictHistoryToFeature && PortalUser.isLoggedIn() && !PortalUser.hasOneOfFeatures([definition.restrictHistoryToFeature])) {
      showsHistory = false
    }
  }

  var historyInit = (
    <div className={classes.historyEnable}>
      {!historyModeOpts.historicalView && showsHistory && (
        <IconButton  className={classes.listFunctionButton} size={"small"} color="primary" aria-label={"Historical View"} onClick={handleHistory(historicalURL)} disabled={historyModeOpts.historicalView}>
          <i className={classNames(classes.historyToggle, 'fa fa-clock')} />
        </IconButton>
      )}
    </div>
  );
  var historyNavigator = (
    <div></div>
  );
  if (historyModeOpts.historicalView) {
    // Formulates the button label based on the updatedAt and updatedBy of the patch
    var historyLabel
    if (historyModeOpts.historicalData[historyModeOpts.historyStep]) {
      var updatedString = ""
      var val = moment(updatedString = historyModeOpts.historicalData[historyModeOpts.historyStep].updatedAt);
      if (val.isValid()) {
        val.add(val.toDate().getTimezoneOffset(), 'm');
        updatedString = val.format('MM/DD/YYYY');
      }
      historyLabel = (
        <div>
          <span style={{display:"block"}}>Viewing {historyModeOpts.historyStep == 0 ? `un-saved changes` : `version ${historyModeOpts.historicalData[historyModeOpts.historyStep].data.version}`} {historyModeOpts.historyStep == 0 ? null : `of ${historyModeOpts.historicalData.length-1}`}</span>
    
          <span style={{display:"block"}}>Updated at {updatedString} by {historyModeOpts.historicalData[historyModeOpts.historyStep].updatedBy}</span>
        </div>
      )
    }


    historyInit = (
      <div></div>
    );
    historyNavigator = (
      <div className={classes.historyArea}>

        {<Button className={classes.historyBack} size={"small"} aria-label="Previous" color="primary" onClick={handleHistoryBack} disabled={!historyModeOpts.historicalData[historyModeOpts.historyStep + 1]}>
          <i className={classNames(classes.historyToggle, 'fa fa-chevron-left')} />
        </Button>}
        {<Button
          size={"small"}
          aria-label="Close"
          onClick={handleHistoryClose}
          className={classes.historyStep}
          disabled={false}>
          {historyLabel}
        </Button>}
        {<Button className={classes.historyForward} size={"small"} aria-label="Next" color="primary" onClick={handleHistoryForward} disabled={historyModeOpts.historyStep <= 0}>
          <i className={classNames(classes.historyToggle, 'fa fa-chevron-right')} />
        </Button>}
      </div>
    );
  }

  // Constructors 
  var fieldArea = renderFields();
  var definitionsArea = renderDefinitions();
  
  if (definition.instructions && !definition.allowsMultiples) {
    instructions = (
      <Typography
        className={classes.instructions}
        variant="body1"
        gutterBottom
        dangerouslySetInnerHTML={{ __html: definition.instructions }}
      />
    );
  }

  if (policyMessages && policyMessages.length > 0) {
    // Without this, the instructions from the definition section get cleared so prime it with this:
  
    var policyInstructions:Array<any> = [];
    if (instructions) {
      policyInstructions.push(instructions)
    }

    for (const pm of policyMessages) {
      if (pm.path == path) {
        
        policyInstructions.push(
          <Typography
            className={getPolicyMessageClass(pm)}
            variant="body1"
            gutterBottom
            dangerouslySetInnerHTML={{ __html: pm.message }}
          />
        );
      }
    }
    instructions = policyInstructions
  }


  if (!fieldArea && !definitionsArea) {
    return null
  }
  // Tech Review: do this better?
  if (isTitleSuppressed) {
    return (
      <div style={definition.styleAttributes} className={definitionClass}>
        {/* {fieldDialog} */}
        {/* {definitionDialog} */}
        {confirmTriggerValidationModal}
        <div className={classes.details}>
          <div className={classes.detailsWrapper}>
            {instructions}
            {fieldArea}
            {definitionsArea}
          </div>
        </div>
      </div>
    );

  } else {
    if (!preventCollapse) {
      // RENDER Single Def and has Accordian (most cases)
      return (
        <div style={definition.styleAttributes} className={definitionClass}>
          {/* {fieldDialog} */}
          {/* {definitionDialog} */}
          {confirmTriggerValidationModal}
          <Accordion elevation={0} defaultExpanded={true} className={classes.paper}>
            {definition.title != null && definition.title != undefined &&  definition.title != "" &&
            
              <AccordionSummary tabIndex={-1} className={classes.summaryPanel} expandIcon={<ExpandMoreIcon />}>
                {titleOverride || definition.title}
                {historyInit}
                {historyNavigator}
                {popperIcon}
              </AccordionSummary>
            }
            <AccordionDetails className={classes.paper}>
              <div className={classes.AccordionDetails}>
                <div className={classes.detailsWrapper}>
                  {instructions}
                  {fieldArea}
                  {definitionsArea}
                  {snackbarContent && <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={open}
                    message={snackbarContent}
                    action={
                      <React.Fragment>
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          sx={{ p: 0.5 }}
                          onClick={()=>{setSnackbarContent(null)}}
                        >
                          <CloseIcon />
                        </IconButton>
                      </React.Fragment>
                    }
                  />
                  }
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      )
    } else {
      // RENDER Single Def and has No Accordian
      if (definition.gridAttributes.lg != 0) {
        
        return (
          <div style={definition.styleAttributes} className={classNames(definitionClass, classes.preventCollapseContainer)}>
            {/* {fieldDialog} */}
            {/* {definitionDialog} */}
            {/* {historyButtons} */}
            {confirmTriggerValidationModal}
            {<Typography variant="h5" className={classes.sectionTitle}>
              {titleOverride || definition.title}
              {historyInit}
              {historyNavigator}
              {popperIcon}
            </Typography>}
              <div className={classes.details}>
                <div className={classes.detailsWrapper}>
                  {instructions}
                  {fieldArea}
                  {definitionsArea}
                </div>
              </div>
          </div>
        );
      } else {
        return (<div />)
      }
    }
  }
}



export default DefinitionSection;